import type { SVGProps } from "react";
import { memo } from "react";
const CodeBuild = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#2E27AD" />
        <stop offset="100%" stopColor="#527FFF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="m65.44 22-5.954-5.451L53.526 22zm-8.238-6.062-12.078.018 6.451 5.127zM51.755 33.5 42.248 37h18.287zM37.798 57h26.798V39H37.798zm11.725-35-6.586-5.234L36.396 22zm-15.214-.885 6.44-5.152-12.837.019zM32.225 22l-6.572-5.274L19.08 22h13.145m-4.352 2h-8.03l8.03 7.965zm0 11.083-9.425 8.582 9.425 9.224zm0 21.054-9.925 9.702V66h9.925zm-9.925-10.174v17.09l8.736-8.54zm0-4.539 8.672-7.896-8.672-8.6zm-.993-20.276 6.43-5.159-6.43.01zM14.97 14h-1.985v10h1.985V14m53.963 9.36a.99.99 0 0 1-.926.64H52.686v8l13.278 5.074-.001.002a1 1 0 0 1 .618.924v20c0 .552-.444 1-.992 1H36.805a.997.997 0 0 1-.992-1V38c0-.428.27-.787.646-.929l-.003-.007L50.701 32v-8H29.858v43c0 .552-.444 1-.993 1h-11.91a.997.997 0 0 1-.992-1V26h-3.97A.997.997 0 0 1 11 25V13c0-.552.445-1 .993-1h3.97c.548 0 .992.448.992 1v.999L59.633 14l9.042 8.26c.303.278.406.715.258 1.1M48.34 55.308l5.776-13.225-1.816-.806-5.777 13.225zm5.426-4.42 1.283 1.527 4.288-3.658a1.007 1.007 0 0 0 .064-1.465l-3.579-3.659-1.413 1.405 2.826 2.89zM40.87 47.984a1 1 0 0 1 .08-1.541l4.87-3.631 1.182 1.607L43.1 47.33l3.275 3.024-1.342 1.475z"
      />
    </g>
  </svg>
);
const Memo = memo(CodeBuild);
export default Memo;
